'use client';

import { useState } from 'react';

import Image from 'next/image';

import { Dealer } from '@gds/Icons/Paths/Dealer';
import { KenticoImage } from '@shared-components/KenticoImage/KenticoImage';

import styles from './DealerLogo.module.css';

const DealerLogo = ({
  logo,
  name,
  isKenticoImage = false,
}: {
  logo?: string;
  name: string;
  isKenticoImage?: boolean;
}) => {
  const [hasError, setHasError] = useState(false);

  const onImgError = () => setHasError(true);

  const renderLogo = () => {
    if (!logo || hasError) {
      return <Dealer color="primary" />;
    }

    if (isKenticoImage) {
      return (
        <KenticoImage
          src={logo}
          alt={name}
          fill
          loading="lazy"
          onError={onImgError}
          style={hasError ? { display: 'none' } : {}}
          sizes="(max-width: 768px) 100px, 150px"
        />
      );
    }

    return (
      <Image
        fill={true}
        src={logo}
        alt={name}
        onError={onImgError}
        style={hasError ? { display: 'none' } : {}}
        sizes="(max-width: 768px) 100px, 150px"
      />
    );
  };

  return (
    <span className={`${styles.bubble} ${!logo || hasError ? styles.noImage : ''}`}>
      {renderLogo()}
    </span>
  );
};
export { DealerLogo };
